<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 5.57076H17.1667M13.5435 0.5V4.12197M4.12319 0.5V4.12197M1.22464 1.94879H16.442C16.442 1.94879 17.1667 1.94879 17.1667 2.67318V16.4367C17.1667 16.4367 17.1667 17.1611 16.442 17.1611H1.22464C1.22464 17.1611 0.5 17.1611 0.5 16.4367V2.67318C0.5 2.67318 0.5 1.94879 1.22464 1.94879Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.3561 12.7581C12.5015 13.0681 12.48 13.4307 12.2956 13.7207C12.2374 13.813 12.1659 13.8954 12.0807 13.9628C11.8136 14.1834 11.4503 14.2472 11.1224 14.1315L4.82196 11.861C4.69028 11.8136 4.59926 11.6916 4.59185 11.5515L4.4454 9.00802C4.44641 8.90188 4.53376 8.81615 4.63989 8.81719C4.65437 8.81682 4.67065 8.81872 4.68466 8.82242L5.83225 9.03067C5.89757 9.04552 5.95186 9.09312 5.97325 9.15751L6.14268 10.4224L7.76719 10.9112L7.40879 7.83138C7.41378 7.69992 7.52499 7.5953 7.65734 7.60147C7.67476 7.60247 7.69308 7.60462 7.71002 7.60969L8.48399 7.81971C8.56195 7.84119 8.62522 7.90016 8.64926 7.97724L9.84741 11.6678L11.7892 12.2752C12.0382 12.3517 12.2425 12.5282 12.3565 12.7633L12.3561 12.7581Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
